import { CustomScroll } from "react-custom-scroll";

export default class OverridedCustomScroll extends CustomScroll {
    prevHeight = 0;

    UNSAFE_componentWillReceiveProps(nextProps) {
        // COPIED CODE START
        this.externalRender = true;
        // COPIED CODE ENDS
        if (this.props.shouldUpdate === false && nextProps.shouldUpdate === true) {
            this.prevHeight = this.contentHeight;
        }
    }

    componentDidUpdate(prevProps, prevState) {
        // COPIED CODE START
        const prevContentHeight = this.contentHeight;
        const prevVisibleHeight = this.visibleHeight;
        const innerContainer = this.getScrolledElement();
        const reachedBottomOnPrevRender = Math.ceil(prevState.scrollPos) >= prevContentHeight - prevVisibleHeight;

        this.contentHeight = innerContainer.scrollHeight;
        this.scrollbarYWidth = innerContainer.offsetWidth - innerContainer.clientWidth;
        this.visibleHeight = innerContainer.clientHeight;
        this.scrollRatio = this.contentHeight ? this.visibleHeight / this.contentHeight : 1;

        this.toggleScrollIfNeeded();

        if (this.props.freezePosition || prevProps.freezePosition) {
            this.adjustFreezePosition(prevProps);
        }
        if (typeof this.props.scrollTo !== "undefined" && this.props.scrollTo !== prevProps.scrollTo) {
            this.updateScrollPosition(this.props.scrollTo);
        } else if (this.props.keepAtBottom && this.externalRender && reachedBottomOnPrevRender) {
            this.updateScrollPosition(this.contentHeight - this.visibleHeight);
        }
        // COPIED CODE ENDS
        if (this.props.shouldUpdate && this.state.scrollPos === 0) {
            this.props.getItems();
        }
        if (Math.ceil(this.state.scrollPos) >= prevContentHeight - prevVisibleHeight && this.props.arrowPresents) {
            this.props.clearArrow();
        }
        this.externalRender = false;
    }
}
